import React from "react";

export interface ILoadingProps {}

const Loading: React.FC<ILoadingProps> = (props) => {
    return (
        <div className="loading-container">
            <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default Loading;
